
import {Component, Vue} from 'vue-property-decorator';
import ContratoViewComponent from "@/components/ContratoViewComponent.vue"

@Component({
  name: "ContratoEdit",
  components: {
    ContratoViewComponent
  }
})
export default class ContratoEdit extends Vue {
}
